import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApiClient from "../../../methods/api/apiClient";
import loader from "../../../methods/loader";
import methodModel from "../../../methods/methods";
import { login_success } from "../../../actions/user";
import "./style.scss";
 import Html from "./Html";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const EditProfile = (p) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const [filters, setFilter] = useState({ page: 1, count: 80, search: "" });
  const [data, setData] = useState("");
  const [form, setForm] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [channelsCategories, setChannelsCategories] = useState([])
  const [affiliateTypeCategories, setAffiliateTypeCategories] = useState([])
  const [products, setProducts] = useState([])
  const [productSelectValues, setSelectProductsValues] = useState([]);
  const [productLoader, setProductLoader] = useState(false);
  const [total, setTotal] = useState(0);
  const [initialSelectedIds, setInitialSelectedIds] = useState([])
  const formValidation = [{ key: "mobileNo", minLength: 10 }];
  const [platforms, setPlatforms] = useState([
    {
      name: '',
      url: '',
    }
  ]);


  const updatePlatforms = (updatedPlatforms) => {
    setPlatforms(updatedPlatforms);
  };

  const handleAddPlatform = () => {
    const newPlatform = {
      name: '',
      url: '',
    };

    const updatedPlatforms = [...platforms, newPlatform];
    updatePlatforms(updatedPlatforms);
  };

  const handlePlatformNameChange = (index, value) => {
    const updatedPlatforms = [...platforms];
    updatedPlatforms[index].name = value;
    updatePlatforms(updatedPlatforms);
  };

  const handlePlatformUrlChange = (index, value) => {
    const updatedPlatforms = [...platforms];
    updatedPlatforms[index].url = value;
    updatePlatforms(updatedPlatforms);
  };

  const handleRemovePlatform = (index) => {
    const updatedPlatforms = [...platforms];
    updatedPlatforms.splice(index, 1);
    updatePlatforms(updatedPlatforms);
  };

  const productCheck = (itm) => {

    let arr = productSelectValues ? [...productSelectValues] : [];
    let existingItemIndex = arr.findIndex((aitm) => aitm === itm._id || aitm === itm.id);

    if (existingItemIndex === -1) {
      arr.push(itm._id || itm.id);
    } else {
      arr.splice(existingItemIndex, 1);
    }
    setSelectProductsValues(arr)
  };
 
  const filter = (p = {}) => {
    setFilter({ ...filters, ...p });
    getProducts(p);
  };

  const gallaryData = () => {
    loader(true);
    let res = { success: true, data: { ...user } }
    if (res.success) {
      setForm({
        ...form,
        ...res.data,
        mobileNo: res?.data?.mobileNo || "+61",
      });
      setPlatforms(res?.data?.social_profiles)
      setData(res.data);
    }
    loader(false);

  };

  const getError = (key) => {
    // return methodModel.getError(key, form, formValidation);
    return false;
  };

  const pageChange = (e) => {
    filter({ page: e });
  };

  const handleSubmitProducts = () => {

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // let invalid = methodModel.getFormError(formValidation, form);
    // if (invalid) return;

    let value = {
      fullName: form.fullName,
      mobileNo: form.mobileNo,
      address:form?.address,
      image: form.image,
      id: user._id,
    };

    loader(true);
    ApiClient.put("user/profile", value).then((res) => {
      if (res.success) {
        let uUser = { ...user, ...value };
        dispatch(login_success(uUser));
      }
      loader(false);
    });
  };

  const uploadImage = (e) => {
    setForm({ ...form, baseImg: e.target.value });
    let files = e.target.files;
    let file = files.item(0);
    loader(true);
    ApiClient.postFormData("upload/image", {
      file: file,
    }).then((res) => {
      if (res.fileName) {
        let image = res.fileName;
        setForm({ ...form, image: image, baseImg: "" });
      } else {
        setForm({ ...form, baseImg: "" });
      }
      loader(false);
    });
  };
 

  useEffect(
    () => {
      if (user && user.loggedIn) {
        gallaryData(); 
      }
    },
    []
    // here '[]' is used for, loop se bachne k liye
  );

  return (
    <>
      <Html
        handleSubmit={handleSubmit}
        setForm={setForm}
        form={form}
        uploadImage={uploadImage}
        getError={getError}
        submitted={submitted}
        channelsCategories={channelsCategories}
        affiliateTypeCategories={affiliateTypeCategories}
        handleAddPlatform={handleAddPlatform}
        handlePlatformNameChange={handlePlatformNameChange}
        handlePlatformUrlChange={handlePlatformUrlChange}
        handleRemovePlatform={handleRemovePlatform}
        platforms={platforms}
        user={user}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        products={products}
        setProducts={setProducts}
        productCheck={productCheck}
        productLoader={productLoader}
        total={total}
        productSelectValues={productSelectValues}
        pageChange={pageChange}
      />
    </>
  );
};

export default EditProfile;
